import { createElement, ReactNode, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

export function DNDSortableListItem(props: Props) 
{
    const
    {
        index,
        itemTypeId,
        isTouch,
        elementTag,
        children,
        preview,
        moveItem
    } = props;
    const ref = useRef<Element>(null);

    const [{ isDragging }, drag] = useDrag(
    {
        type: itemTypeId,
        item: {index, preview},
        collect: function(monitor)
        {
            const isDragging =  monitor.isDragging();
            return {isDragging};
        }
    });

    const [{isOver}, drop] = useDrop<DNDItem, unknown, { isOver: boolean }>(
    {
        accept: itemTypeId,
        drop(item, monitor)
        {
            if (item.index !== index) 
            {
                moveItem(item.index, index);
                item.index = index;
            }
        },
        collect(monitor)
        {
            const isOver = monitor.isOver();
            return {isOver};
        },
    });

    drag(drop(ref));

    return createElement(elementTag, {
        children,
        ref: ref,
        style:
        {
            opacity: (isDragging && !isTouch) ? 0.5 : undefined,
            scale: (isOver && !isDragging) ? 1.1 : undefined,
            cursor: 'grab',
        },
    });
}

interface Props
{
    index: number;
    itemTypeId: string;
    isTouch: boolean;
    elementTag: string;
    children: ReactNode;
    preview: ReactNode;
    moveItem: (oldIndex: number, newIndex: number) => void;
};

export interface DNDItem
{
    index: number;
    type: string;
    preview: ReactNode;
};